/**
 * Tiny clsx-style className combiner. Avoids adding a runtime dep just to
 * concatenate strings — the recording subsystem uses this for conditional
 * classes (pulse, layout breakpoints, etc.).
 */
export function cx(...parts: Array<string | false | null | undefined | 0>): string {
  let out = ''
  for (const p of parts) {
    if (!p) continue
    if (out.length > 0) out += ' '
    out += p
  }
  return out
}
